export const ALL_PAYMENT_METHOD_NAME = 'ALL';
export const CREDIT_CARD_ERROR_TYPE = 'CREDIT_CARD';
export const DEBIT_CARD_ERROR_TYPE = 'DEBIT_CARD';
export const BANKDOWN_ERR_MSG_STATE = {
  DISABLE: 0,
  WARNING: 1
};

export const PAYMENT_TYPES = {
  LOAN: 1,
  CASH: 2,
  CARD: 3,
  PAY_IN_PARTS: 4,
  WALLETS: 5,
  NET_BANKING: 6,
  UPI: 7,
  EMI: 8
};

export const paymentMethodNames = [
  {
    type: PAYMENT_TYPES.CARD,
    payment_method: 'Card'
  },
  {
    type: PAYMENT_TYPES.NET_BANKING,
    payment_method: 'NB'
  },
  {
    type: PAYMENT_TYPES.UPI,
    payment_method: 'UPI'
  },
  {
    type: PAYMENT_TYPES.WALLETS,
    payment_method: 'WALLET'
  },
  {
    type: PAYMENT_TYPES.CASH,
    payment_method: 'Cash'
  }
];

export const paymentGatewayTypes = {
  2: 'Juspay',
  5: 'Ebanx',
  6: 'Propelld',
  7: 'Eduvanz',
  8: 'Isure',
  9: 'Zestmoney'
};

export const STORE_PROCESSOR = 'StoreBased';

export const REFERRAL_SUGGESTIONS_EXP = 'recommended_referral_code';

export const STORESUBSCRIPTION_PROCESSOR = 'StoreSubscriptionBased';
